// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_to-integer.js
// module id = 66
// module chunks = 48 49 50 51